import { create } from "zustand";

export interface IRouteFeatureDialogActions {
    setRoadFeatureDialogIsOpen: (isOpen: boolean) => void;
    setClickedRoadFeature: (feature: any) => void;
}

export interface IRouteFeatureDialogState {
    clickedRoadFeature: any;
    roadFeatureDialogIsOpen: boolean;
    actions: IRouteFeatureDialogActions;
} 
const useRouteFeatureDialogStore = create<IRouteFeatureDialogState>( (set) => ({
    clickedRoadFeature: null,
    roadFeatureDialogIsOpen: false,
    actions: {
        setRoadFeatureDialogIsOpen: (isOpen: boolean) => {
            set({
                roadFeatureDialogIsOpen: isOpen
            })
            
        },
        setClickedRoadFeature: (feature: any) => {
            set({
                clickedRoadFeature: feature
            })
        }
    }
}));

export const useClickedRoadFeature = () => useRouteFeatureDialogStore((state) => state.clickedRoadFeature);
export const useRoadFeatureDialogIsOpen = () => useRouteFeatureDialogStore((state) => state.roadFeatureDialogIsOpen);
export const useRouteFeatureDialogStoreActions = () => useRouteFeatureDialogStore((state) => state.actions);